import React, { FC, useEffect } from 'react'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'
import { useRouteMatch } from 'react-router-dom'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { PAGE_COACHES } from '../../../../../constants/navigation'
import { history } from '../../../../../store'
import {
	getCoachData,
} from '../../../../../store/reducers/coaches/actions'
import CoachOverviewHead from './CoachOverviewHead/CoachOverviewHead'
import CoachOverviewMain from './CoachOverviewMain/CoachOverviewMain'
import { changePatientDataFilterRequest } from '../../../../../store/reducers/patients/actions'

interface RouteParams {
	readonly id: string
}

const CoachOverview: FC = () => {
	const { loading, setLoading, dispatch, isMounted, alert } =
		useDefaultComponentTools(true)
	// const patientID = useTypedSelector(selectPatientID)

	const {
		params: { id },
	} = useRouteMatch<RouteParams>()

	useEffect(() => {
		const getPatientDataAsync = async (id: string): Promise<void> => {
			try {
				await dispatch(getCoachData(id))
				await dispatch(changePatientDataFilterRequest('coachId', id))
			} catch (e: any) {
				'message' in e && e.message && alert.error(e.message)
				history.replace(PAGE_COACHES)
			} finally {
				isMounted() && setLoading(false)
			}
		}

		if (!id) return

		getPatientDataAsync(id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, id])

	return (
		<Box minHeight={'100%'} display={'flex'} flexDirection={'column'}>
			{loading && (
				<Box textAlign={'center'} my={'auto'}>
					<CircularProgress />
				</Box>
			)}

			{!loading && (
				<>
					<CoachOverviewHead />

					<CoachOverviewMain />
				</>
			)}
		</Box>
	)
}

export default CoachOverview
